import React from 'react'

const Whoweserve = () => {
    return (
        <div className="sec sec-cream">
            <div className="container">
                <div className="heading_part">
                    <div className="sec-label"><span className="overline" >Who we serve</span></div>
                    <h2 className="disp-lg">Every stage of love and family-building.</h2>
                    <p className="sec-sub">FutureSoulmates serves people across every life stage — from first relationships at 20 to second marriages at 55, and everyone building a family in between.</p>
                </div>
                <div className="stage-strip">
                    <div className="stage-card">
                        <img src="images/FindingYourPerson.jpg" alt="Young couple in their 20s" loading="lazy" />
                        <div className="stage-overlay">
                            <div className="stage-tag">Age 22–35</div>
                            <h3>Finding Your Person</h3>
                            <p>Partner compatibility + physiological synchrony scoring. Search first. Date who's already compatible.</p>
                        </div>
                    </div>
                    <div className="stage-card">
                        <img src="images/family-planning.jpg" alt="Couple discussing family planning" loading="lazy" />
                        <div className="stage-overlay">
                            <div className="stage-tag">Age 28–45</div>
                            <h3>Family Planning</h3>
                            <p>Carrier risk, HLA immune compatibility, embryo viability prediction. Know before you conceive.</p>
                        </div>
                    </div>
                    <div className="stage-card">
                        <img src="images/api-dating-platform.jpg" alt="Professional meeting and networking" loading="lazy" />
                        <div className="stage-overlay">
                            <div className="stage-tag">Enterprise</div>
                            <h3>API for Dating Platforms</h3>
                            <p>White-label compatibility intelligence for Match, Bumble, Shaadi.com and others. B2B SaaS at $5–15/query.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Whoweserve
